export function buttonPressed(children) {
  for (let i = 0; i < children.length; i++) {
    children[i].classList.toggle('hidden')
    children[i].classList.toggle('visible')
  }
}

export function noContextMenu() {
  const noContextMenuArr = document.getElementsByClassName("noContextMenu") 
  for (let i = 0; i < noContextMenuArr.length; i++) {
    noContextMenuArr[i].addEventListener('contextmenu', event => {
      event.preventDefault();
    });
  }
}